import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

import { Target_Direction } from '@graphql/generated/graphql';

export const Ornament = styled.div`
    display: flex;
    position: absolute;
    right: 16px;
    top: 24px;
`;

export const TargetsCardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    z-index: 1;
`;

export const TargetItem = styled.a(
    ({ theme: { palette, radius } }) => css`
        align-items: center;
        background-color: ${palette.tertiary.background};
        border-radius: ${radius[8]}px;
        cursor: pointer;
        display: flex;
        padding: 12px 16px 12px 12px;
        text-decoration: none;
        width: 100%;
    `,
);

export const TargetItemContent = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    gap: 8px;
`;

export const TargetItemValues = styled.div`
    display: flex;
    gap: 24px;
    align-items: center;
`;

export const TargetsHeader = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 24px;
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const TargetItemContentValues = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const TargetItemPercentageWrapper = styled.div`
    display: flex;
    align-items: center;
`;

export const TargetItemPercentageValue = styled(Typography.TextBody_12_18)<{
    direction: Target_Direction;
}>(
    ({ direction, theme: { palette } }) => css`
        display: flex;
        align-items: center;

        color: ${direction === 'INCREASE'
            ? palette.semantic.success
            : palette.semantic.error};
    `,
);
